import { applyElevatedCornerRadius, applyElevation, applyFontWeightNormal, applyFontWeightSemiBold, applyTypeRampConfig, backgroundColor, ElevationMultiplier, highContrastButtonBackground, highContrastForeground, highContrastHighlightBackground, highContrastSelectedForeground, neutralFillStealthActive, neutralFillStealthHover, neutralForegroundHint, neutralForegroundRest, typeRamp, } from "@microsoft/fast-components-styles-msft";
import { applyFocusVisible, applyMaxLines, directionSwitch, format, toPx, } from "@microsoft/fast-jss-utilities";
import { black, white } from "../utilities/colors";
const cardPadding = 16;
const cardTopPadding = 12;
const cardBottomPadding2x2y = 26;
const attributionRegionHeight = 42;
const centeredInlineFlex = {
    display: "inline-flex",
    "align-items": "center",
};
const styles = {
    contentCard: {
        position: "relative",
        overflow: "hidden",
        display: "flex",
        "flex-direction": "column",
        "&:hover": Object.assign({}, applyElevation(ElevationMultiplier.e6), { "& $contentCard_headingContent": {
                "text-decoration": "underline",
            }, "& $contentCard_image": {
                opacity: ".9",
            } }),
    },
    contentCard_positioningRegion: {
        height: "100%",
        display: "flex",
        "flex-direction": "column",
    },
    contentCard_abstract: Object.assign({ position: "relative", "margin-top": "6px", "min-height": toPx(9 * typeRamp.t7.lineHeight) }, applyMaxLines(9, typeRamp.t7.lineHeight), { "&::after": {
            "box-shadow": format("inset 0 -20px 30px 0 {0}", backgroundColor),
            margin: "0 -20px",
            width: "calc(100% + 40px)",
            height: "60px",
        } }),
    contentCard_attributionRegion: Object.assign({}, centeredInlineFlex, { "box-sizing": "border-box", "align-self": "flex-end", padding: `8px ${toPx(cardPadding)} ${toPx(cardPadding)}`, width: "100%", "max-height": toPx(attributionRegionHeight) }),
    contentCard_attribution: {
        "& + $contentCard_timestamp": {
            "& > span": {
                "margin-left": directionSwitch("6px", ""),
                "margin-right": directionSwitch("", "6px"),
            },
        },
    },
    contentCard_timestamp: Object.assign({}, applyTypeRampConfig("t8"), applyFontWeightNormal(), centeredInlineFlex, { color: neutralForegroundHint }),
    contentCard_contentRegion: {
        display: "flex",
        "flex-direction": "row",
        "flex-wrap": "wrap",
        "align-content": "flex-start",
        padding: `${toPx(cardTopPadding)} ${toPx(cardPadding)} 0`,
        "max-height": `calc(100% - ${toPx(attributionRegionHeight)})`,
    },
    contentCard_heading: Object.assign({ display: "block", "text-decoration": "none", transition: "all .2s ease-in-out", width: "100%", "&::after": {
            top: "0",
            right: "0",
            "z-index": "1",
        } }, applyFocusVisible("& $contentCard_headingContent", {
        "text-decoration": "underline",
    })),
    contentCard_headingContent: Object.assign({}, applyFontWeightSemiBold()),
    contentCard_imageRegion: {
        position: "relative",
        display: "inline-flex",
        "align-self": "flex-start",
        background: neutralForegroundRest(() => white),
    },
    contentCard_image: {
        opacity: "1",
    },
    contentCard_icon: Object.assign({ width: "24px", height: "24px", fill: white }, highContrastForeground),
    contentCard_iconWrapper: Object.assign({ position: "absolute" }, centeredInlineFlex, { width: "48px", height: "48px", "justify-content": "center", "border-radius": "50%", background: "rgba(0,0,0,0.4)", "margin-left": directionSwitch("12px", ""), "margin-right": directionSwitch("", "12px"), bottom: "8px" }),
    contentCard_kicker: Object.assign({ position: "relative", display: "flex", "margin-bottom": "4px", "z-index": "2", "text-decoration": "none", background: "none", border: "none", padding: "0", "font-family": "inherit", "&:hover": {
            "& $contentCard_kickerContent": {
                "text-decoration": "underline",
            },
        } }, applyFocusVisible("& $contentCard_kickerContent", {
        "text-decoration": "underline",
    })),
    contentCard_curatedBy: {
        "margin-left": directionSwitch("auto", ""),
        "margin-right": directionSwitch("", "auto"),
        "max-height": "20px",
    },
    contentCard_kickerContent: {
        color: neutralForegroundHint,
        transition: "all .2s ease-in-out",
    },
    contentCard_actionIcon__trigger: {
        "box-sizing": "border-box",
    },
    contentCard_menuGlyph: {},
    contentCard__hideHeadingHover: {
        "&:hover": {
            "& $contentCard_headingContent": {
                "text-decoration": "none",
            },
        },
    },
    contentCard__imagePriority: {},
    contentCard_actionRegion: {
        display: "inline-flex",
        position: "absolute",
        right: directionSwitch(toPx(cardPadding), ""),
        left: directionSwitch("", toPx(cardPadding)),
        bottom: "8px",
        "z-index": "2",
        "flex-grow": "1",
        "justify-content": "flex-end",
    },
    contentCard_actionIcon: {
        height: "32px",
        width: "32px",
        "margin-left": directionSwitch("4px", ""),
        "margin-right": directionSwitch("", "4px"),
    },
    contentCard__1x_1y: {
        "& $contentCard_positioningRegion": {
            "flex-direction": "row",
        },
        "& $contentCard_contentRegion": {
            flex: "1",
        },
        "& $contentCard_imageRegion": {
            order: "2",
            "margin-top": toPx(cardPadding),
            "margin-right": directionSwitch(toPx(cardPadding), ""),
            "margin-left": directionSwitch("", toPx(cardPadding)),
        },
        "& $contentCard_iconWrapper": {
            width: "32px",
            height: "32px",
            "margin-right": directionSwitch("8px", ""),
            "margin-left": directionSwitch("", "8px"),
        },
        "& $contentCard_icon": {
            width: "16px",
            height: "16px",
        },
        "& $contentCard_imageRegion, & $contentCard_image": Object.assign({}, applyElevatedCornerRadius()),
    },
    contentCard__1x_2y: {},
    contentCard__1x_3y: {},
    contentCard_obscuredRegion: {
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: "0",
            left: "0",
        },
    },
    contentCard__2x_2y: {
        "& $contentCard_imageRegion": {
            position: "absolute",
            "&::after": {
                background: format("linear-gradient(0deg, {0} 0, transparent 100%)", () => black),
                height: "190px",
                width: "100%",
            },
            "& + $contentCard_contentRegion": {
                position: "static",
                "margin-top": "auto",
                "& $contentCard_headingContent": {
                    color: white,
                },
                "& $contentCard_kicker, & $contentCard_curatedBy": {
                    position: "absolute",
                    top: "24px",
                    left: directionSwitch("24px", ""),
                    right: directionSwitch("", "24px"),
                },
                // 2x2 icon wrapper style with image
                "& $contentCard_iconWrapper": {
                    "border-color": white,
                },
                "& $contentCard_icon": {
                    fill: white,
                },
            },
        },
        "& $contentCard_curatedBy": {
            "margin-left": directionSwitch("0", ""),
            "margin-right": directionSwitch("", "0"),
        },
        "& $contentCard_iconWrapper": {
            display: "inline-block",
            bottom: "auto",
            background: "none",
            width: "auto",
            height: "30px",
            "border-radius": "0",
            "border-left": directionSwitch("2px solid", ""),
            "border-right": directionSwitch("", "2px solid"),
            "border-color": neutralForegroundRest,
            position: "relative",
            "vertical-align": "middle",
        },
        "& $contentCard_icon": {
            "margin-left": directionSwitch("10px", ""),
            "margin-right": directionSwitch("", "10px"),
            display: "block",
            "margin-top": "2px",
        },
        "& $contentCard_contentRegion": {
            "z-index": "1",
        },
        "& $contentCard_attributionRegion": {
            position: "relative",
            padding: `${toPx(cardTopPadding)} ${toPx(cardPadding)} ${toPx(cardBottomPadding2x2y)}`,
        },
        "& $contentCard_actionIcon__trigger": {
            bottom: "18px",
        },
        "&$contentCard__imagePriority": {
            "& $contentCard_attributionRegion": {
                "& $contentCard_timestamp, & $contentCard_attribution > span": {
                    color: white,
                },
            },
            "& $contentCard_actionIcon": Object.assign({ "background-color": "transparent" }, highContrastButtonBackground, { "& $contentCard_menuGlyph": Object.assign({ fill: white }, highContrastForeground), "&:hover": Object.assign({ "background-color": neutralFillStealthHover(() => black) }, highContrastHighlightBackground, { "& $contentCard_menuGlyph": Object.assign({}, highContrastSelectedForeground) }), "&:active": {
                    background: neutralFillStealthActive(() => black),
                } }, applyFocusVisible(Object.assign({ "background-color": neutralFillStealthHover(() => black), "border-color": white, "box-shadow": format("inset 0 0 0 1px {0}", () => white) }, highContrastHighlightBackground, { "& $contentCard_menuGlyph": Object.assign({}, highContrastSelectedForeground) }))),
        },
    },
};
export default styles;
